<template>
  <span>{{ convertedNumber }}</span>
</template>

<script>
import { displayNumber } from "../utilities/number";

export default {
  name: "DisplayNumber",
  props: {
    number: {
      type: Number,
      required: true,
    },
    useGrouping: {
      type: String,
      default: 'auto',
    },
    notation: {
      type: String,
      default: 'standard'
    }
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    convertedNumber() {
      return displayNumber(this.number, this.$store.getters.langShortcode, {
        notation: this.notation,
        useGrouping: this.useGrouping,
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
